import type { ApiV2InitResponse } from '@dce-front/hodor-types';
import type { HodorSdkConfig } from '@dce-front/sdk-hodor';
import { init } from '@dce-front/sdk-hodor';
import { getSdkInitParameters } from './getSdkInitParameters';

type FetchInitParameters = {
  config: HodorSdkConfig;
};

export async function fetchInit({
  config,
}: FetchInitParameters): Promise<ApiV2InitResponse> {
  const initResponse = await init(config, getSdkInitParameters());

  return initResponse;
}
